export const OUTPUTS_RECEIVED = "OUTPUTS_RECEIVED";
export const PREPEND_OUTPUT = "PREPEND_OUTPUT";
export const APPEND_OUTPUT = "APPEND_OUTPUT";
export const SETUP_SOCKET = "SETUP_SOCKET";
export const SET_OUTPUT = "SET_OUTPUT";
